<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="outstockRawMaterialCheckForm commonFormStyles">
            <HeaderNav
                header-title="原材料出库表单"
                v-if="!isNews"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <ul class="formList">
                <li>
                    <van-field
                        disabled
                        label="出库单号"
                        :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                        v-model="formData.OutstockNumber"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="物料代码"
                        :left-icon="require('@/assets/images/icons/icon_46@2x.png')"
                        v-model="formData.Materials[0].MaterialCode"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="短描述"
                        :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                        v-model="formData.Materials[0].MaterialShortName"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        readonly
                        label="仓库名称"
                        :disabled="isReadonly"
                        :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                        v-model="formData.StockName"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="出库数量"
                        :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                        v-model="formData.Materials[0].VolumeOutstock"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="出库人"
                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                        v-model="formData.OutstockUserName"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="制单时间"
                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                        v-model="formData.OutstockTime"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="状态"
                        :left-icon="require('@/assets/images/icons/icon_13@2x.png')"
                        v-model="Status"
                    ></van-field>
                </li>
            </ul>
            <footer class="currencyFooterStyle" v-if="!isReadonly">
                <button class="confirm" @click="affirmFun">
                    确认出库
                </button>
                <button class="confirm" @click="backFun">
                    退回
                </button>
            </footer>
        </div>
    </v-touch>
</template>

<script>
import { mixin_MessageJump } from '@/assets/mixin/mixin_MessageJump';
import { HeaderNav } from '@/components/';
export default {
    // 库位表单
    name: 'outstock-raw-material-check-form',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/outstockRawMaterialCheck') {
            this.$store.commit('noKeepAlive', 'outstock-raw-material-check-form');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    mixins: [mixin_MessageJump],
    props: {},
    data() {
        return {
            isReadonly: false,
            formData: {
                Materials: [{
                    MaterialCode: '',
                    MaterialShortName: '',
                    VolumeOutstock: '',
                }],
            },
            Status: '',
            isNews: false,
        };
    },
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        async initpage() {
            this.isNews = this.$route.params.isNews;
            if (this.isNews && this.$route.params.data.tenant_id) {
                // 有tenant_id，消息列表跳转办理页面，判断多租户
                await this.getNewsToken(this.$route.params.data.tenant_id);
            }
            const id = this.$route.params.data.id;
            this.formData = await this.getFormDataRequest(id);
            if (this.formData.Status > 1) {
                this.isReadonly = true;
            }
            this.Status = this.loadStatus(this.formData.Status);
        },
        loadStatus(nub) {
            const staus = ['待提交', '待审核', '未通过', '待出库', '已出库', '已作废'];
            return staus[nub];
        },
        async affirmFun() {
            this.$dialog.confirm({
                message: `确认出库单 \n【${this.formData.OutstockNumber}】出库？`,
            }).then(async () => {
                const res = await this.affirmData(this.formData.Id);
                if (res) {
                    this.$toast('出库成功！');
                }
                this.isReadonly = true;
            });
        },
        async backFun() {
            this.$dialog.confirm({
                message: `确认要退回出库单 \n【${this.formData.OutstockNumber}】？`,
            }).then(async () => {
                const res = await this.backData(this.formData.Id);
                if (res) {
                    this.$toast('退回成功！');
                }
                this.isReadonly = true;
            });
        },
        getFormDataRequest(id) {
            return this.$axios.$get(`/interfaceApi/procurement/outstock/${id}`, { token: this.newsToken });
        },
        affirmData(id) {
            return this.$axios.$post(`/interfaceApi/procurement/outstock/outstock/${id}`, { token: this.newsToken });
        },
        backData(id) {
            return this.$axios.$post(`/interfaceApi/procurement/outstock/back/${id}`, { token: this.newsToken });
        },
    },
};
</script>
<style lang="stylus"></style>
